var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    id: "javascript",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,24h24V0H0V24z M19.784,18.629c-0.255-0.961-2.251-1.185-3.616-2.205c-1.38-0.93-1.709-3.18-0.569-4.471c0.39-0.48,1.034-0.84,1.71-1.005l0.705-0.089c1.365-0.031,2.204,0.329,2.834,1.034c0.182,0.179,0.316,0.36,0.586,0.78c-0.721,0.449-0.721,0.449-1.755,1.125c-0.226-0.48-0.586-0.78-0.976-0.9c-0.6-0.18-1.365,0.014-1.515,0.66c-0.059,0.195-0.045,0.375,0.046,0.705c0.243,0.555,1.061,0.795,1.797,1.14c2.115,0.858,2.828,1.778,3.003,2.873l-0.046-0.067c0.166,0.945-0.045,1.56-0.074,1.65c-0.781,2.67-5.131,2.76-6.871,1.004c-0.36-0.42-0.6-0.629-0.81-1.109l1.83-1.051c0.495,0.75,0.944,1.156,1.755,1.336C18.914,20.174,20.024,19.799,19.784,18.629z M8.133,18.976c0.017,0,0.064,0.091,0.127,0.196c0.233,0.389,0.434,0.659,0.83,0.855c0.386,0.121,1.236,0.209,1.566-0.48c0.201-0.348,0.138-1.479,0.138-2.711c0-1.941,0.009-3.867,0.009-5.805h2.248l-0.004,0.056c0,2.07,0.012,4.125,0,6.179c0.005,1.276,0.113,2.416-0.397,3.346c-0.353,0.72-1.028,1.185-1.811,1.411c-1.203,0.27-2.352,0.105-3.207-0.405c-0.574-0.345-1.019-0.887-1.324-1.517L8.133,18.976z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.39cc7628651e79104ae03bc01d510006.svg";
export { ForwardRef as ReactComponent };